import { render, staticRenderFns } from "./BdoRadios.vue?vue&type=template&id=160e1822&scoped=true"
import script from "./BdoRadios.vue?vue&type=script&lang=js"
export * from "./BdoRadios.vue?vue&type=script&lang=js"
import style0 from "./BdoRadios.vue?vue&type=style&index=0&id=160e1822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e1822",
  null
  
)

export default component.exports